/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Sat Mar 30 2024 17:32:14
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Button } from '@shopify/polaris';

import { routes } from 'src/routes';
import history from 'src/routes/history';

import Error404 from 'src/assets/images/shopify-integration/404.svg';

type ComposedProps = WithI18nProps;

type State = {};

class ThemeNotExist extends Component<ComposedProps, State> {
  render() {
    const { i18n } = this.props;

    return (
      <div className="BC-Page BC-Shopify-Integration-Setup">
        <div className="error-container">
          <img src={Error404} alt="404" />
          <h1 className="title">
            {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Common.themeNoExist')}
          </h1>
          <Button onClick={this.handleGoBack}>
            {i18n.translate('AdminHTML.ShopifyIntegrationSettings.Common.backToIntegration')}
          </Button>
        </div>
      </div>
    );
  }

  handleGoBack = () => {
    // Go back to theme
    history.push(routes.shopifyIntegration.view());
  };
}

export default withI18n()(ThemeNotExist);
